/**
 * Garzi de UX pentru Respond (Securitee > Incidents si tichetul XDR): ce nu are
 * sens sa lase ecranul sa ceara, fiindca agentul refuza oricum pe statie.
 * Autoritatea ramane refuzul din agent; astea doar nu mai trimit comanda moarta.
 */

/** root (uid 0 pe Linux) nu se poate deconecta: agentul refuza; izolare sau shutdown in loc. */
export const isRoot = (user: string): boolean => user.trim().toLowerCase() === 'root'
